module.exports = __webpack_public_path__ + "img/tomcat_big.73b89654.png";